export const importFromCsv = {
  title: '洗浄方法のCSVインポート',
  importSuccessfully: '洗浄方法を正常にインポートしました！',
  importFailed: '洗浄方法のインポートに失敗しました！',
}
